// 화면 19 — Stock Score Explorer (Phase C) 타입.
// 권위:
//   - docs/ARCH_DASHBOARD.md v1.10.3 §4.19 / §6.2 (라우트 /leading/scores, 폴링 300s, WebSocket 미사용)
//   - docs/QUANT_SPEC.md §2.5 / §2.5.6 — final_score / perf_score / soft_rank / volume_rank / percentile / band 산식
//   - docs/ARCH_DATA.md §5.21 — stock_daily_score (90일 retention, PK (date, symbol))
//
// 백엔드 DTO snake_case. envelope.data 만 axios interceptor 가 언랩.
// Phase B (LeadingStocks) 와 동일한 Band 타입·색상 매핑·날짜 유틸 공유.

import { Band } from '../LeadingStocks/types';

export type { Band };
export { bandColor, bandSoftBg } from '../LeadingStocks/types';

// ── /api/v1/stocks/search 응답 ──────────────────────────────────
export interface StockMatch {
  symbol: string;
  name: string;
  market_code: string; // '0' (KOSPI) | '10' (KOSDAQ)
  market_name: string;
  is_active: boolean;
}

export interface StockSearchResult {
  query: string;
  limit: number;
  matches: StockMatch[];
}

// ── /api/v1/stocks/{symbol}/score-history 응답 ──────────────────
export interface ScoreHistoryRow {
  trading_date: string;
  final_score: number | null;
  perf_score: number | null;
  soft_rank: number | null;
  volume_rank: number | null;
  final_score_percentile: number | null;
  band: Band;
  in_top45: boolean;
}

export interface ScoreHistory {
  symbol: string;
  name: string;
  sector: string | null; // stock_canonical_sectors 최근 매핑
  days: number;
  rows: ScoreHistoryRow[];
}

// ── /api/v1/stocks/score-distribution/bands 응답 ─────────────────
export interface BandDistributionRow {
  trading_date: string;
  A_count: number;
  B_count: number;
  C_count: number;
  unclassified_count: number;
}

export interface BandsDistribution {
  days: number;
  rows: BandDistributionRow[];
}

// ── /api/v1/stocks/score-distribution/percentile 응답 ────────────
export interface PercentileHistogramBin {
  bin_start: number;
  bin_end: number;
  count: number;
}

export interface PercentileHistogram {
  trading_date: string;
  bins: number;
  histogram: PercentileHistogramBin[];
  total_count: number;
}

// ── UI 토글 — 시장 전체 밴드 누적 막대 lookback (ARCH §4.19 — 30/60/90) ──
export type BandDistributionDays = 30 | 60 | 90;
export const BAND_DISTRIBUTION_DAYS: readonly BandDistributionDays[] = [30, 60, 90] as const;

// 종목 시계열 days (cap 90 — AC-DB-PRD-16).
export const SCORE_HISTORY_DAYS = 90;
